export const getToFixedNumber = (number: string | number, numbersAfterComma = 2): number => {
  const numberValue = Number(number);

  return Number(numberValue.toFixed(numbersAfterComma));
};
